import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

@Pipe({
  name: 'utcToLocalDateOnly',
  standalone: true,
})
export class UtcToLocalDatePipeOnly implements PipeTransform {
  transform(value: string | Date): string {
    if (!value) {
      return '';
    }

    const UTC_DATE = new Date(value);
    const LOCAL_DATE = new Date(
      UTC_DATE.getUTCFullYear(),
      UTC_DATE.getUTCMonth(),
      UTC_DATE.getUTCDate()
    );

    return new Intl.DateTimeFormat('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    }).format(LOCAL_DATE);
  }
}
